<template lang="html">
  <div class="result-wrapper-background">
    <div class="result-wrapper">
      <div class="filters-wrapper">
        <categories
          :categories="categories"
          :collaps="true"
          :active="parseInt(parameters.category)"
          @changeCategory="changeCategory"
        />

        <!-- <div class="filter-wrapper">
          <dropdown
            :defaultText="getNewestDefaultText"
            :selected="getNewestSelected"
            :list="newestList"
            @changeOption="changeNewest"
          />
        </div> -->
        <div class="filter-wrapper">
          <likeMenu
            :defaultText="getNewestDefaultText"
            :selected="getNewestSelected"
            :list="newestList"
            @changeOption="changeNewest"
          />

          <!-- <div class="filter-wrapper">
          <dropdown
            :defaultText="$t('profile.purchase.region')"
            :selected="getRegionSelected"
            :list="region.dropdownList"
            @changeOption="changeRegions"
          />
        </div> -->

          <likeMenu
            :defaultText="$t('profile.purchase.region')"
            :selected="getRegionSelected"
            :list="region.dropdownList"
            @changeOption="changeRegions"
          />

          <!-- <div class="filter-wrapper">
          <dropdown
            :defaultText="getExpiryDefaultText"
            :selected="getExpirySelected"
            :list="expiryList"
            @changeOption="changeExpiry"
          />
        </div> -->

          <likeMenu
            :defaultText="getExpiryDefaultText"
            :selected="getExpirySelected"
            :list="expiryList"
            @changeOption="changeExpiry"
          />
        </div>
        <div
          v-if="getFiltersList && Object.keys(getFiltersList).length > 0"
          class="filter-wrapper side"
          style="padding: 20px"
        >
          <dropdown
            v-for="(value, name) in getFiltersList"
            :key="name"
            :defaultText="name"
            :selected="getFilterValue(name)"
            :list="value"
            @changeOption="changeFilter(name, $event)"
            :removable="true"
            @remove="changeFilter(name, null)"
            style="margin-bottom: 20px"
          />
        </div>
        <!-- <div @click="getProducts" class="btn">
          {{ $t("result.search") }}
        </div> -->
      </div>
      <div class="main-wrapper">
        <div class="upper-filters-wrapper">
          <!-- <dropdown
            :defaultText="getSortDefaultText"
            :selected="getSortSelected"
            :list="sortList"
            @changeOption="changeSort"
          /> -->

          <badge
            v-if="parameters.category"
            :badge="getBadgeInfo('category', parameters.category)"
            @remove="removeBadge"
            style="margin-right: auto;"
          />
          <!-- <badge
            v-for="(value, key) in parameters"
            :key="key + value"
            :badge="getBadgeInfo(key, value)"
            @remove="removeBadge"
          /> -->
          <div class="filter-wrapper">
            <dropdown
              :defaultText="getCurrencyDefaultText"
              :selected="getCurrencySelected"
              :list="currencyList"
              style="width:200px"
              @changeOption="changeCurrency"
            />
          </div>
          <div
            :title="!parameters.cur_id ? $t('main.chooseCurrency') : ''"
            class="filter-wrapper"
          >
            <dropdown
              :disabled="!parameters.cur_id"
              :defaultText="getSortDefaultText"
              :selected="getSortSelected"
              :list="sortList"
              style="width:200px"
              @changeOption="changeSort"
            />
          </div>
        </div>
        <categories
          :categories="categories"
          :collaps="true"
          :active="parseInt(parameters.category)"
          @changeCategory="changeCategory"
        />
        <div class="category-title small">
          <badge
            v-if="parameters.category"
            :badge="getBadgeInfo('category', parameters.category)"
            @remove="removeBadge"
            style="margin-bottom: 20px;"
          />
          <div class="title" @click="openFilters = !openFilters">
            <span>{{ $t("profile.purchase.filters") }}</span>
            <img
              src="@/assets/newImges/icons/btnRight.svg"
              alt="slider btn right"
              :class="{ rotate: openFilters }"
            />
          </div>
          <div class="line"></div>
        </div>
        <div v-if="openFilters" class="filters-wrapper small">
          <div class="filter-wrapper">
            <dropdown
              :defaultText="getCurrencyDefaultText"
              :selected="getCurrencySelected"
              :list="currencyList"
              @changeOption="changeCurrency"
            />

            <dropdown
              :disabled="!parameters.cur_id"
              :defaultText="getSortDefaultText"
              :selected="getSortSelected"
              :list="sortList"
              @changeOption="changeSort"
            />

            <dropdown
              :defaultText="getNewestDefaultText"
              :selected="getNewestSelected"
              :list="newestList"
              @changeOption="changeNewest"
            />

            <dropdown
              :defaultText="$t('profile.purchase.region')"
              :selected="getRegionSelected"
              :list="region.dropdownList"
              @changeOption="changeRegions"
            />

            <dropdown
              :defaultText="getExpiryDefaultText"
              :selected="getExpirySelected"
              :list="expiryList"
              @changeOption="changeExpiry"
            />
          </div>
          <div
            v-if="getFiltersList && Object.keys(getFiltersList).length > 0"
            class="filter-wrapper"
          >
            <dropdown
              v-for="(value, name) in getFiltersList"
              :key="name"
              :defaultText="name"
              :selected="getFilterValue(name)"
              :list="value"
              @changeOption="changeFilter(name, $event)"
              :removable="true"
              @remove="changeFilter(name, null)"
            />
          </div>
          <!-- <div @click="getProducts" class="btn">
            {{ $t("result.search") }}
          </div> -->
        </div>
        <!-- <div class="category-title">
          <div v-if="getSelectedCategory !== null" class="title">
            {{ getSelectedCategory.cat_name }}
          </div>
          <div class="line"></div>
        </div> -->
        <div v-if="isSpinner" class="no-result-spin">
          <div class="spinner"></div>
        </div>
        <div v-else-if="products.length > 0" class="items-wrapper">
          <item
            v-for="(product, index) in products"
            :key="index"
            :itemData="product"
          />
        </div>
        <div v-else class="no-result">
          {{ $t("result.noResult") }}
        </div>
        <div
          v-if="products.length > 0 && !isSpinner"
          class="pagination-wrapper"
        >
          <span class="pagination-text">
            {{ getPaginationText }}
          </span>
          <paginate
            v-model="page"
            :page-count="pageCount"
            :prev-text="getPaginationImages('Left')"
            :next-text="getPaginationImages('Right')"
            :container-class="'pagination'"
            :page-class="'page'"
            :click-handler="changePage"
          >
          </paginate>
        </div>
      </div>
      <!-- <div v-if="false" class="baner-wrapper">
        <div class="baner" style="overflow: hidden;">
          <img src="@/assets/images/defBanner.png" alt="baner image" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
import Paginate from "vuejs-paginate";
import Item from "@/components/item/item.vue";
import Dropdown from "@/components/dropdown.vue";
import Badge from "@/components/badge.vue";
import Categories from "@/components/topSection/categories.vue";
import likeMenu from "@/components/shared/likeMenu.vue";

export default {
  name: "Result",
  components: {
    Categories,
    Item,
    Dropdown,
    Badge,
    Paginate,
    likeMenu
  },
  data() {
    return {
      parameters: {},
      categories: null,
      products: [],
      pageCount: 0,
      perPage: 12,
      page: 1,
      filters: {},
      selectedFilters: {},
      itemsCount: 0,
      currencyList: [],
      openFilters: false,
      region: {
        label: "Region",
        value: null,
        dropdownList: []
      },
      isSpinner: true
    };
  },
  mounted() {
    // this.setParametersFromQuery()
    // this.getCategories()
    // eventBus.$on('updateSearch', search => {
    //   let copy = Object.assign({}, this.parameters)
    //   copy.search = search
    //   this.parameters = copy
    // })
    // eventBus.$on('refresh', this.getItems)
    // this.scrollToTop()
    // this.getProducts()
  },
  activated() {
    this.setParametersFromQuery();
    this.getCategories();
    this.getCurrencies();
    this.getRegions();
    eventBus.$on("updateSearch", search => {
      let copy = Object.assign({}, this.parameters);
      copy.search = search;
      this.parameters = copy;
    });
    eventBus.$on("refresh", this.getItems);
    this.scrollToTop();
    this.getProducts();
  },
  methods: {
    getItems() {
      this.isSpinner = true;
      let params = Object.assign({}, this.parameters);
      params.page = this.page;
      api
        .getProducts(params)
        .then(res => {
          this.products = res.data.data;
          this.itemsCount = res.data.meta.items;
          this.pageCount = Math.ceil(res.data.meta.items / this.perPage);
          this.isSpinner = false;
        })
        .catch(e => {
          console.log(e);
          this.isSpinner = false;
        });
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 500);
    },
    getCategories() {
      api
        .getCategories()
        .then(res => {
          // get all categories, add open property, check if subCategory is activ and open that category
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i].open = false;
            const subCategories = res.data.data[i].subCategories;
            if (this.parameters.category && subCategories) {
              for (var j = 0; j < subCategories.length; j++) {
                if (
                  subCategories[j].cat_id === parseInt(this.parameters.category)
                ) {
                  res.data.data[i].open = true;
                }
              }
            }
          }
          this.categories = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getCurrencies() {
      api
        .getCurrencies()
        .then(res => {
          let result = [];
          for (var i = 0; i < res.data.data.length; i++) {
            let obj = {
              label: res.data.data[i].cur_name,
              value: res.data.data[i].cur_id
            };
            result.push(obj);
          }
          this.currencyList = result;
        })
        .catch(e => {
          console.log(e);
        });
    },
    preventClickSort(e) {
      console.log(e);
      e.preventDefault();
      e.stopPropagation();
      // if (!this.parameters.cur_id) {
      //   e.preventDefault()
      //   e.stopPropagation()
      // }
    },
    setParametersFromQuery() {
      this.parameters = JSON.parse(JSON.stringify(this.$route.query));
    },
    changeCategory(category) {
      let copy = Object.assign({}, this.parameters);
      copy.category = category.cat_id;
      this.parameters = copy;
      this.$router.replace({ query: copy }).catch(() => {});
    },
    changeCurrency(option) {
      // let copy = Object.assign({}, this.parameters);
      // copy.cur_id = currency.value;
      // this.parameters = copy;

      let copy = Object.assign({}, this.parameters);
      if (!option || this.parameters.cur_id === option.value) {
        delete copy.cur_id;
        delete copy.sort;
      } else {
        copy.cur_id = option.value;
      }
      this.parameters = copy;
      this.$router.replace({ query: copy }).catch(() => {});
    },
    changeSort(option) {
      // let copy = Object.assign({}, this.parameters);
      // copy.sort = option.value;
      // this.parameters = copy;

      let copy = Object.assign({}, this.parameters);
      if (!option || this.parameters.sort === option.value) {
        delete copy.sort;
      } else {
        copy.sort = option.value;
      }
      this.parameters = copy;
      this.$router.replace({ query: copy }).catch(() => {});
    },
    changeNewest(option) {
      // let copy = Object.assign({}, this.parameters);
      // copy.newest = option.value;
      // this.parameters = copy;

      let copy = Object.assign({}, this.parameters);
      if (this.parameters.newest === option.value) {
        delete copy.newest;
      } else {
        copy.newest = option.value;
      }
      this.parameters = copy;
      this.$router.replace({ query: copy }).catch(() => {});
    },
    changeExpiry(option) {
      // console.log(option, this.parameters);
      // let copy = Object.assign({}, this.parameters);
      // copy.expiry = option.value ? option.value : option;
      // this.parameters = copy;

      let copy = Object.assign({}, this.parameters);
      if (this.parameters.expiry === option.value) {
        delete copy.expiry;
      } else {
        copy.expiry = option.value;
      }
      this.parameters = copy;
      this.$router.replace({ query: copy }).catch(() => {});
    },
    changeRegions(option) {
      // let copy = Object.assign({}, this.parameters);
      // copy.reg_id = option.value;
      // this.parameters = copy;

      let copy = Object.assign({}, this.parameters);
      if (this.parameters.reg_id === option.value) {
        delete copy.reg_id;
      } else {
        copy.reg_id = option.value;
      }
      this.parameters = copy;
      this.$router.replace({ query: copy }).catch(() => {});
    },
    changeFilter(name, option) {
      if (option !== null) {
        let copy = Object.assign({}, this.selectedFilters);
        copy[name] = option;
        this.selectedFilters = copy;
      } else {
        let copy = Object.assign({}, this.selectedFilters);
        delete copy[name];
        this.selectedFilters = copy;
      }
    },
    removeBadge(badge) {
      if (this.parameters[badge.key]) {
        let copy = Object.assign({}, this.parameters);
        delete copy[badge.key];
        if (badge.key === "cur_id") {
          delete copy["sort"];
        }
        this.parameters = copy;
        let res = Object.assign({}, this.parameters);
        this.$router.replace({ query: res }).catch(() => {});
        this.getItems();
      }
    },
    getSelectedCategoryMethod() {
      let res = null;
      if (
        this.parameters.category &&
        this.categories &&
        this.categories.length > 0
      ) {
        for (var i = 0; i < this.categories.length; i++) {
          if (
            this.categories[i].cat_id === parseInt(this.parameters.category)
          ) {
            res = this.categories[i];
          }
          let subCategories = this.categories[i].subCategories;
          if (subCategories) {
            for (var j = 0; j < subCategories.length; j++) {
              if (
                subCategories[j].cat_id === parseInt(this.parameters.category)
              ) {
                res = subCategories[j];
              }
            }
          }
        }
      }
      return res;
    },
    getCurrencySelectedMethod() {
      let res = null;
      if (this.parameters.cur_id) {
        for (var i = 0; i < this.currencyList.length; i++) {
          if (this.currencyList[i].value === this.parameters.cur_id) {
            res = this.currencyList[i];
          }
        }
      }
      return res;
    },
    getSortSelectedMethod() {
      let res = null;
      if (this.parameters.sort) {
        for (var i = 0; i < this.sortList.length; i++) {
          if (this.sortList[i].value === this.parameters.sort) {
            res = this.sortList[i];
          }
        }
      }
      return res;
    },
    getNewestSelectedMethod() {
      let res = null;
      if (this.parameters.newest) {
        for (var i = 0; i < this.newestList.length; i++) {
          if (
            parseInt(this.newestList[i].value) ===
            parseInt(this.parameters.newest)
          ) {
            res = this.newestList[i];
          }
        }
      }
      return res;
    },
    getExpirySelectedMethod() {
      let res = null;
      if (this.parameters.expiry) {
        for (var i = 0; i < this.expiryList.length; i++) {
          if (
            parseInt(this.expiryList[i].value) ===
            parseInt(this.parameters.expiry)
          ) {
            res = this.expiryList[i];
          }
        }
      }
      return res;
    },
    getRegionSelectedMethod() {
      let res = null;
      if (this.parameters.reg_id !== null) {
        for (var i = 0; i < this.region.dropdownList.length; i++) {
          if (
            parseInt(this.region.dropdownList[i].value) ===
            parseInt(this.parameters.reg_id)
          ) {
            res = this.region.dropdownList[i];
          }
        }
      }
      return res;
    },
    getPaginationImages(side) {
      // "@/assets/newImges/icons/sliderBtnLeft.svg"
      // require(`@/assets/icons/pagination${side}.png`);
      let path = require(`@/assets/newImges/icons/sliderBtn${side}.svg`);
      return `<img src='${path}' alt='pagination left image'>`;
    },
    changePage(page) {
      this.page = page;
    },
    handleFilters() {
      this.filters = {};
      if (this.parameters.category) {
        let params = {
          id: this.parameters.category
        };
        api.getFilters(params).then(res => {
          let arr = res.data.res;
          // console.log(arr)
          for (var i = 0; i < arr.length; i++) {
            this.createFilter(arr[i]);
          }
        });
      } else {
        this.selectedFilters = {};
      }
    },
    createFilter(data) {
      if (data.options && data.options.length > 0) {
        let arr = [];
        for (var i = 0; i < data.options.length; i++) {
          let obj = {
            label: data.options[i].cvl_value,
            value: data.options[i].cvl_id
          };
          arr.push(obj);
        }
        this.filters[data.cha_type] = arr;
      }
    },
    getProducts() {
      this.isSpinner = true;
      if (
        this.$route.query.category &&
        this.$route.query.category !== this.parameters.category
      ) {
        this.selectedFilters = {};
      }
      let res = Object.assign({}, this.parameters);
      this.$router.replace({ query: res }).catch(() => {});

      let params = Object.assign({}, this.parameters);
      this.page = 1;
      params.page = 1;
      if (
        Object.keys(this.selectedFilters).length === 0 &&
        this.selectedFilters.constructor === Object
      ) {
        console.log("");
      } else {
        console.log("");
        let arr = [];
        for (var variable in this.selectedFilters) {
          if (this.selectedFilters.hasOwnProperty(variable)) {
            arr.push(this.selectedFilters[variable].value);
          }
        }
        params.filters = JSON.stringify(arr);
      }
      api
        .getProducts(params)
        .then(res => {
          this.products = res.data.data;
          this.itemsCount = res.data.meta.items;
          this.pageCount = Math.ceil(res.data.meta.items / this.perPage);
          this.isSpinner = false;
        })
        .catch(e => {
          console.log(e);
          this.isSpinner = false;
        });
      // console.log(params)
      // if (params.category) {
      this.handleFilters();
      // }
    },
    getRegions() {
      api
        .getRegions()
        .then(res => {
          this.region.dropdownList = this.fixDropdownData(
            res.data.data,
            "regions"
          );
          // this.region.dropdownList = res.data.data
          // console.log(JSON.stringify(res.data.data))
        })
        .catch(e => {
          console.log(e);
        });
    },
    fixDropdownData(data, type) {
      let res = [];
      if (type === "regions") {
        for (let i = 0; i < data.length; i++) {
          let obj = {
            label: data[i].reg_name,
            value: data[i].reg_id
          };
          res.push(obj);
        }
      }
      return res;
    }
  },
  computed: {
    getFiltersList() {
      return this.filters;
    },
    sortList() {
      return [
        {
          label: this.$t("filters.sortUpper"),
          value: "desc"
        },
        {
          label: this.$t("filters.sortLower"),
          value: "asc"
        }
      ];
    },
    newestList() {
      return [
        {
          label: this.$t("filters.newest7"),
          value: 7
        },
        {
          label: this.$t("filters.newest30"),
          value: 30
        },
        {
          label: this.$t("filters.newest90"),
          value: 90
        }
      ];
    },
    expiryList() {
      return [
        {
          label: this.$t("filters.expiry1"),
          value: 1
        },
        {
          label: this.$t("filters.expiry3"),
          value: 3
        },
        {
          label: this.$t("filters.expiry5"),
          value: 5
        }
      ];
    },
    getCurrencyDefaultText() {
      return this.$t("details.details.cur_id");
    },
    getSortDefaultText() {
      return this.$t("dropdown.sort");
    },
    getNewestDefaultText() {
      return this.$t("filters.newest");
    },
    getExpiryDefaultText() {
      return this.$t("filters.expiry");
    },
    getBadgeInfo() {
      return (key, value) => {
        let res = {
          key: key,
          value: value
        };
        if (key === "category") {
          let category = this.getSelectedCategoryMethod();
          res.label = category ? category.cat_name : null;
        }
        if (key === "sort") {
          let sort = this.getSortSelectedMethod();
          res.label = sort.label;
        }
        if (key === "newest") {
          let newest = this.getNewestSelectedMethod();
          console.log(newest);
          res.label = newest.label;
        }
        if (key === "expiry") {
          let expiry = this.getExpirySelectedMethod();
          res.label = expiry.label;
        }
        if (key === "reg_id") {
          let region = this.getRegionSelectedMethod();
          res.label = region.label;
        }
        return res;
      };
    },
    getCurrencySelected() {
      return this.getCurrencySelectedMethod();
    },
    getSortSelected() {
      return this.getSortSelectedMethod();
    },
    getNewestSelected() {
      return this.getNewestSelectedMethod();
    },
    getExpirySelected() {
      return this.getExpirySelectedMethod();
    },
    getRegionSelected() {
      return this.getRegionSelectedMethod();
    },
    getSelectedCategory() {
      return this.getSelectedCategoryMethod();
    },
    getFilterValue() {
      return name => {
        let obj = null;
        if (this.selectedFilters.hasOwnProperty(name)) {
          obj = this.selectedFilters[name];
        }
        return obj;
      };
    },
    getPaginationText() {
      let str = "";
      str += this.$t("result.display") + " ";
      str += String(this.page * 12 - 11);
      str += " - ";
      if (parseInt(this.page * 12) >= parseInt(this.itemsCount)) {
        str += String(this.itemsCount);
      } else {
        str += String(this.page * 12);
      }
      str += " " + this.$t("result.of") + " ";
      str += String(this.itemsCount);
      str += " " + this.$t("result.products");
      return str;
    }
  },
  watch: {
    parameters: {
      handler(oldVal, newVal) {
        this.isSpinner = true;
        let oldValue = JSON.parse(JSON.stringify(oldVal));
        let newValue = JSON.parse(JSON.stringify(newVal));
        if (oldValue.category !== newValue.category) {
          this.selectedFilters = {};
          this.handleFilters();
        }
        // if (oldValue.newest !== newValue.newest) {
        //   return;
        // }
        // if (oldValue.expiry !== newValue.expiry) {
        //   return;
        // }
        // if (oldValue.cur_id !== newValue.cur_id) {
        //   return;
        // }
        // if (oldValue.sort !== newValue.sort) {
        //   return;
        // }
        // if (oldValue.reg_id !== newValue.reg_id) {
        //   return;
        // }
        // let res = Object.assign({}, this.parameters);
        // this.$router.replace({ query: res }).catch(() => {});

        let params = Object.assign({}, this.parameters);
        this.page = 1;
        params.page = 1;
        if (
          Object.keys(this.selectedFilters).length === 0 &&
          this.selectedFilters.constructor === Object
        ) {
          console.log("");
        } else {
          console.log("");
          let arr = [];
          for (var variable in this.selectedFilters) {
            if (this.selectedFilters.hasOwnProperty(variable)) {
              arr.push(this.selectedFilters[variable].value);
            }
          }
          params.filters = JSON.stringify(arr);
        }
        api
          .getProducts(params)
          .then(res => {
            this.products = res.data.data;
            this.itemsCount = res.data.meta.items;
            this.pageCount = Math.ceil(res.data.meta.items / this.perPage);
            this.isSpinner = false;
          })
          .catch(e => {
            console.log(e);
            this.isSpinner = false;
          });
        // console.log(params)
        // this.handleFilters();
      },
      deep: true
    },
    selectedFilters: {
      handler() {
        // console.log(params)
        // if (params.category) {
        //   this.handleFilters()
        // }
      },
      deep: true
    },
    page: {
      handler() {
        this.isSpinner = true;
        let params = Object.assign({}, this.parameters);
        params.page = this.page;
        api
          .getProducts(params)
          .then(res => {
            this.products = res.data.data;
            this.pageCount = Math.ceil(res.data.meta.items / this.perPage);
            this.isSpinner = false;
          })
          .catch(e => {
            console.log(e);
            this.isSpinner = false;
          });
        this.scrollToTop();
      }
    },
    "$route.params.lang": {
      handler: function() {
        this.getCategories();
        this.getRegions();
      },
      deep: true,
      immediate: true
    }
  },
  destroyed() {
    // eventBus.$off('updateSearch')
    // eventBus.$off('refresh')
  },
  deactivated() {
    eventBus.$off("updateSearch");
    eventBus.$off("refresh");
  }
};
</script>

<style lang="scss" scoped>
.no-result-spin {
  display: flex;
  justify-content: center;
  // .spinner {
  //   width: 50px;
  //   height: 50px;
  // }
}
.result-wrapper-background {
  background: $gray-blue-400 !important;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;

  .result-wrapper {
    display: flex;
    height: 100%;
    max-width: 1326px;
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    @import "@/assets/scss/btnStyles.scss";

    .dropdown-wrapper .header-wrapper span {
      text-align: left;
    }
    .btn {
      margin-top: 20px;
    }

    .filters-wrapper {
      margin-right: 40px;
      margin-bottom: 150px;

      .categories-wrapper {
        height: 450px;
        min-width: 240px !important;
        width: 326px;
        margin-right: 0;
      }
      .filter-wrapper {
        margin-top: 20px;
        box-sizing: border-box;
        background-color: $gray-blue-100;
        border: 1px solid $gray-blue-500;
        border-radius: 12px;
        padding: 20px 0 20px 20px;
      }
      .filter-wrapper.disabled {
        opacity: 0.5;
      }
    }
    .main-wrapper {
      // flex-grow: 1;
      // width: 1100px;
      flex-grow: 1;

      .filters-wrapper.small {
        display: none;
      }

      .upper-filters-wrapper,
      .category-title,
      .items-wrapper,
      .pagination-wrapper {
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .pagination-text {
          font-size: 13px;
          line-height: 21px;
          color: $blue-400;
        }
      }
      .pagination-wrapper {
        justify-content: space-between;
      }
      .category-title.small {
        display: none;
      }
      .categories-wrapper {
        display: none;
        width: 100% !important;
        height: 300px !important;
        margin-right: 0px;
      }
      .upper-filters-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;
        margin-bottom: 0px;

        .badge-wrapper,
        .dropdown-wrapper {
          margin-right: 10px;
          margin-bottom: 20px;
        }
      }
      .category-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 25px;

        .title {
          margin-right: 10px;
          font-weight: bold;
          font-size: 16px;
          line-height: 26px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: $blue-300;
        }
        .line {
          flex-grow: 1;
          height: 1px;
          background: rgba(0, 0, 0, 0.15);
        }
      }
      .items-wrapper {
        // display: grid;
        grid-gap: 30px;
        width: 100%;
        flex-wrap: wrap;
        // grid-template-columns: repeat(4,1fr);
        align-items: start;

        .item-wrapper {
          background: white;
          margin-right: 0px;
        }
      }
    }
    // .baner-wrapper {
    //   margin-left: 40px;
    // }
  }
}
.category-title.small {
  background-color: $gray-100;
  padding: 20px 20px;
  border: 1px solid $gray-blue-500;
  border-radius: 12px;
  .title {
    // padding: 0 22px;
    margin-right: 0 !important;
    display: flex;
    justify-content: space-between;
  }
  .line {
    display: none;
  }
  img {
    cursor: pointer;
  }
}
.rotate {
  transform: rotate(90deg);
}
// @media only screen and (max-width: 1650px) {
//   .items-wrapper {
//     grid-template-columns: repeat(3,1fr) !important;
//   }
//   .main-wrapper {
//     width: 820px !important;
//     flex-grow: 0 !important;
//   }
// }
// @media only screen and (max-width: 1370px) {
//   .items-wrapper {
//     grid-template-columns: repeat(2,1fr) !important;
//   }
//   .main-wrapper {
//     width: 540px !important;
//     flex-grow: 0 !important;
//   }
// }
// @media only screen and (max-width: 1100px) {
//   .items-wrapper {
//     grid-template-columns: repeat(1,1fr) !important;
//   }
//   .main-wrapper {
//     width: 260px !important;
//     flex-grow: 0 !important;
//   }
// }
@media only screen and (max-width: 1000px) {
  // .main-wrapper {
  //   width: 60% !important;
  //   flex-grow: 0 !important;
  //
  //   .category-title.small {
  //     display: flex !important;
  //   }
  // }
  .upper-filters-wrapper {
    display: none !important;
  }
  .result-wrapper {
    margin: 50px;
    .filters-wrapper {
      display: none;
    }
  }
  .filters-wrapper.small {
    display: block !important;
    margin-right: 0px !important;
    margin-bottom: 40px !important;
    .filter-wrapper {
      padding: 20px 10px !important;
    }

    .dropdown-wrapper {
      margin-bottom: 20px;
    }
    .dropdown-wrapper:last-of-type {
      margin-bottom: 0px;
    }
  }
  .main-wrapper {
    .categories-wrapper {
      display: block !important;
      margin-bottom: 20px;
    }
    .category-title {
      display: block !important;
    }
  }
}
@media only screen and (max-width: 948px) {
  .items-wrapper {
    justify-content: center !important;
  }
}
@media screen and (max-width: 700px) {
  .main-wrapper {
    box-sizing: border-box;
    width: 90% !important;
    // margin-left: 5%;
  }
  .items-wrapper {
    max-width: 100% !important;
    grid-template-columns: repeat(2, 1fr) !important;
  }
  .result-wrapper {
    margin: 0 auto;
    display: flex;
    flex-direction: column !important;
    width: 100% !important;
    align-items: center;

    .baner-wrapper {
      box-sizing: border-box;
      margin: 0 !important;
      width: 100%;
      display: flex;
      flex-direction: row !important;
      justify-content: space-around !important;

      .baner {
        margin: 4%;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .items-wrapper {
    // padding-left: 20%;
    grid-template-columns: repeat(1, 1fr) !important;
    grid-gap: 10px !important;
  }
}
@media screen and (max-width: 420px) {
  // .items-wrapper{
  //    padding-left: 5%;
  //   grid-template-columns: repeat(1,1fr) !important;
  // }
  .result-wrapper {
    padding: 0px;
    margin: 0px;
    .main-wrapper {
      /*display: flex;
  align-content: center;
  flex-direction:column;
  */
      box-sizing: border-box;
      width: 90% !important;
    }
    .baner-wrapper {
      box-sizing: border-box;
      margin: 0 !important;
      padding: 0px;
      width: 100%;
      display: block;
      .baner {
        margin: 4%;
      }
    }
  }
}
</style>
<style lang="scss">
// ul.pagination {
//   display: flex;
//   list-style-type: none;
//   align-items: center;
//   padding-left: 0px;
//   font-family: Outfit;

//   li {
//     margin-right: 10px;
//     height: 20px;
//     min-width: 20px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     position: relative;

//     a {
//       // outline: none;
//       // width: 100%;
//       // height: 100%;
//       // font-weight: bold;
//       // font-size: 13px;
//       // line-height: 20px;

//       font-weight: 500;
//       font-style: Medium;
//       font-size: 18px;
//       line-height: 26px;
//       letter-spacing: 0%;
//       color: $gray-blue-1300;
//     }
//   }
//   li:first-of-type,
//   li:last-of-type {
//     border: 1px solid $gray-blue-700; // $gray-blue-700
//     box-shadow: 0px 2px 5px #0000000f;
//     border-radius: 10px;
//     height: 60px;
//     width: 60px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     cursor: pointer;
//     background: $gray-100;
//     padding: 0px;

//     a {
//       display: flex;
//       justify-content: center;
//       align-items: center;
//     }
//   }
//   li:first-of-type:active,
//   li:last-of-type:active {
//     box-shadow: 0px 2px 5px #00000000;
//   }
//   li.disabled {
//     box-shadow: none;
//     cursor: default;
//     a {
//       cursor: default;
//     }
//   }
//   li:last-child {
//     margin-right: 0px;
//   }
//   li.active {
//     // box-shadow: 0px -2px 0px $main-color;
//     // color: $main-color;
//     // border-top: 2px solid $main-color;
//     cursor: default;
//     a {
//       cursor: default;
//       color: $blue-600;
//     }
//   }
// }
</style>
